import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_a2jsa7xbgn: FaireCollectionEntity = {
  token: "pbc_a2jsa7xbgn",
  type: "collection",
  name: "single stickers",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7bf8ce81a33ba0414ec7675301a2f4c77de37ec767efadb7e54948bef8733843.jpeg",
  itemCount: 49,
  description:
    "Beautifully designed watercolor sticker sheets and singles, crafted with care and perfect for gifting, journaling, and adding a cheerful handmade touch to everyday moments.",
  brandToken: "b_mmdanrh9jf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:09:21.925Z",
    importedBy: "entity-db-import-collections",
  },
};
